export default __webpack_public_path__ + "static/media/deutschrad.ba696247.jpg";